import BtnPost from "../../../../shared/btn/btn"

const CreatePost = (props) =>{

    const iconRoute = environment.DOMAIN + `/wp-content/themes/observatorio-omt-web/assets/icons/add.svg`;

    return(
        <>
            <BtnPost 
                btnType = {'primary-botton'}
                widthBtn = ''
                customCss = {'js-creaste-post js-show-modal'}
                text = {'Hacer una pregunta'}
                svgIcon = {iconRoute}
            />
        </>
    )
}

export default CreatePost